module.exports = __webpack_public_path__ + "img/refund.b102e6b8.png";